import useMediaQuery from '@mui/material/useMediaQuery'
import { globalTheme } from '../../Components/themes/globalTheme'

export const useDynamicTheme = () => {
  const theme = globalTheme()

  const isMobile = useMediaQuery(theme.breakpoints.down('sm'))

  return { theme, isMobile }
}